"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAlertError = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconAlertError = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12s12-5.372 12-12c0-6.627-5.373-12-12-12zm0 9.454l2.758-2.757a1.5 1.5 0 012.121 0l.424.424a1.5 1.5 0 010 2.121L14.546 12l2.757 2.758a1.5 1.5 0 010 2.121l-.424.424a1.5 1.5 0 01-2.121 0L12 14.546l-2.758 2.757a1.5 1.5 0 01-2.121 0l-.424-.424a1.5 1.5 0 010-2.121L9.454 12 6.697 9.242a1.5 1.5 0 010-2.121l.424-.424a1.5 1.5 0 012.121 0L12 9.454z"
}));
exports.IconAlertError = IconAlertError;
//# sourceMappingURL=IconAlertError.js.map